<template>
  <div class="page">
    <div class="screenLine">
        <div class="imgItem" style="display: inline-block">
          <img
                :src="qrImgUrl"
                alt=""
                style="width: 100%; height: 100%;"
              />
        
      </div>
    </div>
    <div class="btn" @click="handleSunmitClick">下载</div>
  </div>
</template>
  
  <script>
  import axios from "axios";
export default {
  props: {
    id: {
      type: String,
      default: "",
    },
    pic: {
      default: "",
    },
  },
  data() {
    return {
      qrImgUrl:''
    };
  },
  mounted() {

this.getCageQr()
  },
  methods: {
    getCageQr() {
      let params = {
        petId: this.id,
      };
      let loading = this.$loading();
      axios
        .get(
          process.env.VUE_APP_Url_8000 + "/api/product/pet/qrcode",

          {
            params,
            responseType: "blob",
          }
        )
        .then((response) => {
          loading.close();
          var url = window.URL.createObjectURL(response.data); //创建下载的链接
          this.qrImgUrl = url;
        })
        .catch((err) => {
          console.log(err);
        });
    },
     // 下载图片
     handleSunmitClick() {
      let a = document.createElement("a");
      a.href = this.qrImgUrl;
      a.download = this.id;
      a.click();
      this.$emit("submit");
    },
  },
};
</script>
  
  <style lang="scss" scoped>
.page {
  min-height: 734px;
  //   background: #fff;
  margin-top: 12px;
  font-size: 14px;
}
.screenLine {
}
.imgItem{
  width: 500px;
  height: 350px;
}
// 上传图片
.avatar-uploader .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}

.avatar-uploader .el-upload:hover {
  border-color: #409eff;
}

.avatar-uploader-icon {
  border: 1px dashed #d9d9d9;
  width: 300px;
  height:450px;
  // background: #979797;
  line-height: 450px;
  text-align: center;
  font-size: 30px;
  color: #8c939d;
}

.avatar {
  // margin: 20px;
  width: 300px;
  height:450px;
  display: block;
  object-fit: cover;
}

.btn {
  margin-top: 10px;
  margin-left: 30px;
  width: 98px;
  line-height: 40px;
  text-align: center;
  background: linear-gradient(135deg, #5685ff 0%, #3569ff 100%);
  border-radius: 10px;
  font-size: 16px;
  font-weight: bold;
  color: #fff;
  cursor: pointer;
  margin-left: 20px;
}
</style>